import SettingsProvider from "./SettingsProvider";

export default SettingsProvider;
